import { createSlice } from '@reduxjs/toolkit';

interface IShakeSlice {
	isShaking: boolean;
}

const initialState: IShakeSlice = {
	isShaking: false,
};

const shakeSlice = createSlice({
	name: 'shake',
	initialState,
	reducers: {
		startShake: (state) => {
			state.isShaking = true;
		},
		stopShake: (state) => {
			state.isShaking = false;
		},
	},
});

export const { startShake, stopShake } = shakeSlice.actions;
export default shakeSlice.reducer;
